import { DailyMenuChangeSetSelectedItem, SubGroupSelectionMap } from '@/types'
import store from '@/store'
import {
  DAILY_MENU_TOP_GROUP_CHANGE_SET,
  DAILY_MENU_TOP_GROUP_OFFER, MENU_OFFER,
} from '@/store/getter-types'
import _ from 'lodash'
import {
  SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET
} from '@/store/mutation-types'

import MenuGroupItem from '@/model/MenuGroupItem'
import DailyMenuOption from '@/model/DailyMenuOption'
import MenuReservation from '@/model/MenuReservation'
import Moment from 'moment'
import MenuReservationItem from '@/model/MenuReservationItem'
import Configuration from "@/model/Configuration";

export function updateSelectedItem (selectedItem: DailyMenuChangeSetSelectedItem): void {

  const changeSet: any | undefined = store.getters[DAILY_MENU_TOP_GROUP_CHANGE_SET]

  if (changeSet) {
    const newChangeSet = _.cloneDeep(changeSet)
    const foundItemIndex: number | undefined = _.findIndex(newChangeSet.selectedItemList, function (item: DailyMenuChangeSetSelectedItem) {
      return item.menuGroup.id === selectedItem.menuGroup.id
    })

    if (foundItemIndex >= 0) {
      newChangeSet.selectedItemList.splice(foundItemIndex, 1, selectedItem)

    } else {

      newChangeSet.selectedItemList.push(selectedItem)
    }

    newChangeSet.selectedItemList = newChangeSet.selectedItemList.filter((item: DailyMenuChangeSetSelectedItem) => {
      return item.selectedItem === 'none' ? false : true
    })

    store.commit(SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET, newChangeSet)
  }

}

export function updateSelectedItemByOfferId (reservations: any): void {

  const topGroup: any | undefined = store.getters[DAILY_MENU_TOP_GROUP_OFFER]

  const iterateResGroups = (group: MenuGroupItem, offer_id: any) => {

    let option: DailyMenuChangeSetSelectedItem | undefined = undefined

    group.subGroupList.forEach((subGroup: any) => {
      if (subGroup.subGroupList.length > 0) {
        option = iterateResGroups(subGroup, offer_id)
      } else {
        const selectedOption = _.find(subGroup.optionList, (option: any) => {
          return option.offer.id === offer_id.id
        })

        if (selectedOption) {
          option = {
            selectedItem: selectedOption,
            menuGroup: subGroup
          }
        }
      }
    })

    return option
  }

//console.log("topGroup",topGroup)
  if (topGroup) {
    const newTopGroup = _.cloneDeep(topGroup)

    const foundGroup: any | undefined = _.find(reservations, function (item: any) {
      return item.topMenuGroup.id === topGroup.id
    })

    //console.log("foundGroup",foundGroup)
    if (foundGroup) {
      foundGroup.reservedOfferCollection.forEach((offer: any) => {
        let item = iterateResGroups(topGroup, offer)
        //console.log("item...............",item)
        if (item)
          updateSelectedItem(item)
      })

    }

    // items.forEach( (item:DailyMenuChangeSetSelectedItem) => {
    //   updateSelectedItem( item )
    // })
  }

}

export function createInitialDailyMenuTopGroupChangeSetUpdate (item: any, dbItemData: any): any {
  //console.log("item..item",item)
  //console.log("item..dbItemData",dbItemData)

  const iterateGroups = (groups: MenuGroupItem[]) => {
    let options: DailyMenuChangeSetSelectedItem[] = []
    groups.forEach((group: MenuGroupItem) => {
      if (group.subGroupList.length > 0) {
        options = options.concat(iterateGroups(group.subGroupList))
      } else {
        const selectedOption = group.selectedOption
        if (selectedOption) {
          options.push({
            selectedItem: selectedOption,
            menuGroup: group
          })
        }
      }
    })
    return options
  }

  const foundReservationItem: any | undefined = _.find(dbItemData, function (dbItem: any) {
    const selectedDate = Moment(item.day)
    const dbItemDate = Moment(dbItem.date)
    return dbItemDate.format('Y-MM-DD') === selectedDate.format('Y-MM-DD')
  })

  const changeSet = {
    date: item.day,
    status: item.status,
    user_id: item.user_id,
    topGroupId: item.topGroup.id,
    reservationId: foundReservationItem ? foundReservationItem.id : undefined,
    selectedItemList: iterateGroups([item.topGroup])
  }

  return changeSet
}

// nastavy status ci je na konkretny den a konkretnu topGroup vytvoprena rezervacia
// status hodnoty: no-reservation | active | noactive
export function getReservationStatus (day: string, rangeReservation: MenuReservation, topGroupItem: MenuGroupItem): any {

  const selectedDate = Moment(day)
  const selectedTopGroupId = topGroupItem.id

  const foundReservation: MenuReservationItem | undefined = _.find(rangeReservation.reservationList, function (item: any) {
    const item_date = Moment(item.date)
    return item_date.format('Y-MM-DD') === selectedDate.format('Y-MM-DD') && item.topMenuGroup === selectedTopGroupId
  })

  let status = ''
  if (foundReservation) {

    status = foundReservation.status
  } else {
    status = 'no-reservation'
  }

  return status
}

/**
 * @deprecated
 * @param date
 */
export function isValidDateForOrdering (date: Date): boolean {
  return isDateAfterDeadline(new Date, date)
}

export function getDailyMenuReservation (resDay: any): any {

  let reservedOfferCollection = resDay.reservedOfferCollection
  let topMenuGroup = resDay.topMenuGroup
  let status = resDay.status
  let boarderNote = resDay.boarderNote
  let acceptanceStatus = Object.create(
      {
        name: ''
      }
  )

  let dailyMenuReservationData = Object.create(
    {
      group: '',
      date: resDay.date,
      options: [],
      status: resDay.status,
      isToday: false,
      isTommorow: false,
      boarderNote : resDay.boarderNote,
    }
  )

  const iterateGroups = (groups: MenuGroupItem[]) => {
    let options: any[] = []

    if (groups) {
      groups.forEach((group: MenuGroupItem) => {
        if (group.subGroupList.length > 0) {
          options = options.concat(iterateGroups(group.subGroupList))
        } else {
          const selectedOption = _.find(group.optionList, (option: any) => {
            let selectedResOption = undefined
            if (option.offer && option.offer.id) {
              const selectedResOption = _.find(reservedOfferCollection, (resOption: any) => {
                return option.offer.id === resOption.id
              })
              return selectedResOption
            }

            return undefined
          })
//console.log("selectedOption",selectedOption)
          if (selectedOption) {
            options.push(selectedOption)
          }
        }
      })
    }

    return options
  }

  const menoOffer: any | undefined = store.getters[MENU_OFFER]
  menoOffer.menuList.forEach((menuDay: any) => {
    const date = menuDay.date
    var iscurrentDate = Moment(date).isSame(resDay.date, 'day')
    let tomorrow = Moment(new Date()).add(1, 'days')
    var isTommorow = Moment(date).isSame(tomorrow, 'day')
    let today = Moment(new Date())
    var isToday = Moment(date).isSame(today, 'day')

    if (iscurrentDate) {
      var groupList = menuDay.menuGroupList
      groupList.forEach((group: any) => {

        if (group.id == topMenuGroup.id) {
          dailyMenuReservationData.group = group.title
          dailyMenuReservationData.date = resDay.date
          dailyMenuReservationData.status = resDay.status
          dailyMenuReservationData.isToday = isToday
          dailyMenuReservationData.isTommorow = isTommorow
          dailyMenuReservationData.timeBlock = resDay.timeBlock.title
          dailyMenuReservationData.acceptanceStatus = resDay.acceptanceStatus ? resDay.acceptanceStatus.name : 'accepted'

          let options: MenuGroupItem[] = iterateGroups([group])
          dailyMenuReservationData.options = options

        }
      })
    }
  })
  return dailyMenuReservationData
}

export function validateOrderCorrectness (selection: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>, menuGroupItem: MenuGroupItem, configuration: Configuration[]): boolean {

  let subGroupIdList: string[] = []
  let conditions: boolean[] = []
  menuGroupItem.subGroupList.forEach((item: MenuGroupItem) => {
    item.tags.forEach((i: any) =>{
      configuration.forEach((c: Configuration) => {
        const foundTag: any = c.tags.find((t: any) => t.id === i.id)
        if(foundTag && !subGroupIdList.includes(item.id)){
          //@ts-ignore
          if(c && c.settings && c.settings['configuration_group.is_mandatory']  &&  c.settings['configuration_group.single_item']) {
            const foundItem: any = selection.get(item)
            conditions.push(foundItem ? true : false)
            subGroupIdList.push(item.id)
          //@ts-ignore
          } else if(c && c.settings && c.settings['configuration_group.is_mandatory']  &&  !c.settings['configuration_group.single_item']) {
            const foundItem: any = selection.get(item)
            conditions.push(foundItem && foundItem.length > 0 ? true : false)
            subGroupIdList.push(item.id)
          }
        }
      })
    })
  })
  return !conditions.includes(false)
  /*let conditions: boolean[] = []
  menuGroupItem.subGroupList.forEach((item: MenuGroupItem) => {
    const settings: any = config.get(item.title.toLowerCase())
    if(settings) {
      if(settings['configuration_group.is_mandatory']) {
        const foundItem: any = selection.get(item)
        conditions.push(foundItem ? true : false)
      }
    }
  })

  return !conditions.includes(false)*/

  //const config: any | undefined = store.getters[GET_CONFIG]
  /*let conditions: boolean[] = []
  let selectionSubGroupIdList: number[] = []
  selection.forEach((value: any, key: any) => {
    selectionSubGroupIdList.push(key.id)
  })
  config.tagConfig.forEach((item: any) => {
    menuGroupItem.subGroupList.forEach((i: MenuGroupItem) => {
      const foundItem = i.tags.find((a: any) => a.title === item.title)
      if(foundItem && item.mandatory) {
        conditions.push(selectionSubGroupIdList.includes(parseInt(i.id)))
      }
    })
  })

  return conditions.every(v => v)*/

  /*let hasSoup, hasMainCourse = false

  selection.forEach((option, group) => {
    if (group.kind === 'polievka' && option) {
      hasSoup = true
    }

    if (group.kind === 'hlavne-jedlo' && option) {
      hasMainCourse = true
    }
  })

  return (hasSoup && hasMainCourse) || false*/
}

export function isSelectionDifferentThenReservation (referenceReservation: MenuReservationItem[], selection: SubGroupSelectionMap, isMultiple: boolean): boolean {
  if(!isMultiple && _.first(referenceReservation) && _.first(referenceReservation)!.reservedOfferCollection){
    const existingIds = _.first(referenceReservation)!.reservedOfferCollection.map((i: { id: number }) => i.id)
    let selectedIds: number[] = [] //Array.from(selection.values()).map((v: DailyMenuOption) => v.offer && parseInt(v.offer.id))
    selection.forEach((value: any, key: any) => {
      if(value instanceof Array) {
        value.forEach((item: DailyMenuOption) => {
          if( item.offer && item.offer.id) {
            selectedIds.push(parseInt(item.offer.id))
          }
        })
      } else {
        if(value.offer && value.offer.id) {
          selectedIds.push(parseInt(value.offer.id))
        }
      }
    })
    return _.difference(selectedIds, existingIds).length > 0 || selectedIds.length !== existingIds.length
  } else {
    let existingIds: number[] = []
    referenceReservation.forEach((item: MenuReservationItem) => {
      item.reservedOfferCollection?.forEach((i: { id: number }) => {
        existingIds.push(i.id)
      })
    })
    let selectedIds: number[] = [] //Array.from(selection.values()).map((v: DailyMenuOption) => v.offer && parseInt(v.offer.id))
    selection.forEach((value: any, key: any) => {
      if(value instanceof Array) {
        value.forEach((item: DailyMenuOption) => {
          if( item.offer && item.offer.id) {
            selectedIds.push(parseInt(item.offer.id))
          }
        })
      } else {
        if(value.offer && value.offer.id) {
          selectedIds.push(parseInt(value.offer.id))
        }
      }
    })
    return _.difference(selectedIds, existingIds).length > 0 || selectedIds.length !== existingIds.length
  }
}

export function isDateAfterDeadline (checkDate: Date, itemDate: Date): boolean {
  const itemDeadline = Moment(itemDate)
    .subtract(1, 'day')
    .hours(18)
    .minutes(0)
    .seconds(0)

  return Moment(checkDate).diff(itemDeadline) < 0
}
